import React, { Suspense, useEffect, useRef, useState } from 'react';
import { Link, Slot, usePathname } from 'expo-router';
import Logo from '@/components/Icons/Logo';
import { useTheme } from '@/context/ThemeContext';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';
import { LearnProgressProvider } from './LearnProgress';
import './learn.css';

const Search = React.lazy(() => import('./LearnSearchDialog'));
export default function LearnLayout() {
  const pathname = usePathname();
  const { theme, colors } = useTheme();
  const palette = getCatalogPalette(theme);
  const [searchOpen, setSearchOpen] = useState(false);
  const scrollRef = useRef(null);
  const searchRef = useRef(null);
  useEffect(() => { scrollRef.current?.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    const shortcut = event => { if ((event.metaKey || event.ctrlKey) && event.key === 'k') { event.preventDefault(); setSearchOpen(true); } };
    document.addEventListener('keydown', shortcut);
    return () => document.removeEventListener('keydown', shortcut);
  }, []);
  return <LearnProgressProvider>
    <div className="learn-app" data-theme="light" style={{
      '--learn-bg': colors.solid_color_primary,
      '--learn-ink': colors.text_color_primary,
      '--learn-muted': colors.text_color_secondary,
      '--learn-surface': palette.preview,
      '--learn-border': palette.border,
      '--learn-control': palette.activeBorder,
      '--learn-card': palette.surface,
      '--learn-card-hover': palette.hover,
      '--learn-card-border': palette.border,
    }}>
      <header className="learn-nav"><div className="learn-nav-inner">
        <div className="learn-brand"><Link href="/" aria-label="Gab AI home"><Logo width={24} height={24} color={colors.text_color_primary} /></Link><span aria-hidden="true" className="learn-nav-divider" /><Link href="/learn">Learn</Link></div>
        <nav aria-label="Learn navigation">
          <button ref={searchRef} onClick={() => setSearchOpen(true)} className="learn-nav-search"><span aria-hidden="true">⌕</span> Search lessons</button>
          <Link href="/docs" className="learn-nav-docs">Docs</Link>
          <Link href="/" className="learn-button learn-button-small">Open Gab AI <span aria-hidden="true">↗</span></Link>
        </nav>
      </div></header>
      <div className="learn-scroll" ref={scrollRef}>
        <main id="main-content" tabIndex={-1} className="learn-main"><Slot /></main>
        <footer className="learn-footer"><Link href="/learn">Gab AI Learn</Link><span>Learn something. Make something.</span><Link href="/docs">Need product help? Visit Docs ↗</Link></footer>
      </div>
      {searchOpen && <Suspense fallback={<div className="learn-search-loading" role="status">Opening lesson search… <button onClick={() => setSearchOpen(false)}>Cancel</button></div>}><Search isOpen onClose={() => { setSearchOpen(false); searchRef.current?.focus(); }} /></Suspense>}
    </div>
  </LearnProgressProvider>;
}
